<div class="modal-all">
  <div class="modal-header">
    <span class="modal-header-text">
      <ng-container [ngSwitch]="type_info">
        <span *ngSwitchCase="'du'">
          {{ "modals.add_service.duplicate_title_text" | translate }} -
          {{ service_info?.orderHash }}
        </span>
        <span *ngSwitchCase="'ed'">
          {{ "modals.add_service.edit_title_text" | translate }} -
          {{ service_info?.orderHash }}
        </span>
        <span *ngSwitchDefault>
          {{ "modals.add_service.title" | translate }}
        </span>
      </ng-container>
    </span>

    <button
      tuiIconButton
      appearance="icon"
      type="button"
      icon="tuiIconCloseLarge"
      (click)="closeCanvas()"
    ></button>
  </div>

  <div class="modal-body tui-space_y-6">
    <div id="modal_show_countries_phones"></div>

    <div class="notification-container" *ngIf="type_info === 'du'">
      <tui-icon class="mr-2" icon="tuiIconInfoLarge"></tui-icon>
      <span>
        {{ "modals.add_service.duplicate_title_complement" | translate }}
      </span>
    </div>

    <form tuiForm [formGroup]="form" class="form-container">
      <fieldset
        tuiFieldset
        legend="Cliente / Zona Operativa"
        class="fieldset-container"
      >
        <div>
          <span class="text-field-set-title">
            {{ "modals.add_service.clientAndZone" | translate }}</span
          >
        </div>

        <div>
          <label class="label_form"
            >{{ "modals.add_service.client_input" | translate }}*</label
          >

          <ng-select
            formControlName="clientName"
            class="custom_select custom_select_single w-100"
            [items]="clients"
            bindLabel="businessName"
            [placeholder]="'modals.add_service.select_client' | translate"
            [loading]="clientsLoaded"
          >
            <ng-template ng-option-tmp let-item="item">
              {{ stringifyNameclient(item) }}
            </ng-template>
          </ng-select>

          <div
            class="error-text"
            *ngIf="
              form.get('clientName')?.touched && form.get('clientName')?.invalid
            "
          >
            <span
              *ngIf="form.get('clientName')?.hasError('required')"
              class="text-danger"
            >
              {{ "modals.add_service.field_required" | translate }}
            </span>
          </div>
        </div>

        <label class="label_form"
          >{{ "modals.add_service.zone_input" | translate }}*</label
        >

        <ng-select
          formControlName="zone"
          [items]="zones"
          bindLabel="zoneName"
          class="custom_select custom_select_single w-100"
          [placeholder]="'modals.add_service.select_zone' | translate"
          [loading]="zonesLoaded"
        ></ng-select>

        <div
          class="error-text"
          *ngIf="form.get('zone')?.touched && form.get('zone')?.invalid"
        >
          <span
            *ngIf="form.get('zone')?.hasError('required')"
            class="text-danger"
          >
            {{ "modals.add_service.field_required" | translate }}
          </span>
        </div>
      </fieldset>

      <!-- -------- Fecha / Hora ------------------------------------- -->
      <fieldset
        tuiFieldset
        legend="Día y hora del servicio"
        class="fieldset-container"
      >
        <span class="text-field-set-title">{{
          "modals.add_service.date_input" | translate
        }}</span>

        <div>
          <label class="label_form">
            {{ "modals.add_service.date_input" | translate }}*</label
          >
          <input
            type="date"
            formControlName="serviceStartDate"
            tuiTextfieldSize="s"
            class="form-control"
          />

          <div
            class="error-text"
            *ngIf="
              form.get('serviceStartDate')?.touched &&
              form.get('serviceStartDate')?.invalid
            "
          >
            <span
              *ngIf="form.get('serviceStartDate')?.hasError('required')"
              class="text-danger"
            >
              {{ "modals.add_service.field_required" | translate }}
            </span>
          </div>
        </div>

        <div>
          <label class="label_form">
            {{ "modals.add_service.type_hour_input" | translate }}*
          </label>

          <ng-select
            formControlName="singleTime"
            class="custom_select custom_select_single w-100"
            [items]="hourTypes"
            bindLabel="label"
            bindValue="value"
            [placeholder]="'modals.add_service.select_type_hour' | translate"
          >
          </ng-select>

          <div
            class="error-text"
            *ngIf="
              form.get('singleTime')?.touched && form.get('singleTime')?.invalid
            "
          >
            <span
              *ngIf="form.get('singleTime')?.hasError('required')"
              class="text-danger"
            >
              {{ "modals.add_service.field_required" | translate }}
            </span>
          </div>
        </div>

        <div *ngIf="form.value.singleTime === 'Hora fija'">
          <!-- hora fija -->

          <label class="label_form">
            {{ "modals.add_service.fixed_hour_input" | translate }}*
          </label>

          <tui-input
            formControlName="serviceStartHour"
            [tuiTextfieldLabelOutside]="true"
            maxlength="5"
            (input)="onTimeInput('serviceStartHour')"
            class="input_form"
          >
            HH:mm
          </tui-input>

          <div
            class="error-text"
            *ngIf="
              form.get('serviceStartHour')?.touched &&
              form.get('serviceStartHour')?.invalid
            "
          >
            <span
              *ngIf="form.get('serviceStartHour')?.hasError('required')"
              class="text-danger"
            >
              {{ "modals.add_service.field_required" | translate }}
            </span>

            <span
              *ngIf="form.get('serviceStartHour')?.hasError('pattern')"
              class="text-danger"
            >
              {{ "modals.add_service.invalid_time_format" | translate }}
            </span>
          </div>
        </div>

        <!-- franja horaria -->
        <div *ngIf="form.value.singleTime === 'Franja horaria'">
          <label class="label_form">
            {{ "modals.add_service.franje_hour_input" | translate }}*
          </label>

          <div class="row gx-2">
            <div class="col">
              <tui-input
                formControlName="workdayStartTime"
                maxlength="5"
                (input)="onTimeInput('workdayStartTime')"
                [tuiTextfieldLabelOutside]="true"
                class="input_form"
              >
                HH:mm
              </tui-input>

              <div
                class="error-text"
                *ngIf="
                  form.get('workdayStartTime')?.touched &&
                  form.get('workdayStartTime')?.invalid
                "
              >
                <span
                  *ngIf="form.get('workdayStartTime')?.hasError('required')"
                  class="text-danger"
                >
                  {{ "modals.add_service.field_required" | translate }}
                </span>

                <span
                  *ngIf="form.get('workdayStartTime')?.hasError('pattern')"
                  class="text-danger"
                >
                  {{ "modals.add_service.invalid_time_format" | translate }}
                </span>
              </div>
            </div>
            <div class="col">
              <tui-input
                formControlName="workdayEndTime"
                [tuiTextfieldLabelOutside]="true"
                class="input_form"
                maxlength="5"
                (input)="onTimeInput('workdayEndTime')"
              >
                HH:mm
              </tui-input>

              <div
                class="error-text"
                *ngIf="form.get('workdayEndTime')?.touched"
              >
                <span
                  *ngIf="form.get('workdayEndTime')?.hasError('required')"
                  class="text-danger"
                >
                  {{ "modals.add_service.field_required" | translate }}
                </span>

                <span
                  *ngIf="form.get('workdayEndTime')?.hasError('pattern')"
                  class="text-danger"
                >
                  {{ "modals.add_service.invalid_time_format" | translate }}
                </span>

                <span *ngIf="form.hasError('missingRange')" class="text-danger">
                  {{ "modals.add_service.missing_range" | translate }}
                </span>

                <span *ngIf="form.hasError('invalidRange')" class="text-danger">
                  {{ "modals.add_service.invalid_range" | translate }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <!-- -------- Vehículo ----------------------------------------- -->
      <fieldset tuiFieldset class="fieldset-container">
        <span class="text-field-set-title">{{
          "modals.add_service.vehicle_info_section" | translate
        }}</span>

        <div>
          <label class="label_form">
            {{ "modals.add_service.type_car_input" | translate }}*</label
          >

          <ng-select
            formControlName="vehicleTypeName"
            [items]="VehicleChassisType"
            bindValue="value"
            [searchable]="false"
            class="custom_select custom_select_single w-100"
            [placeholder]="'modals.add_service.select_vehicle_type' | translate"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ "enums.vehicles." + item.real_name | translate }}
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
              {{ "enums.vehicles." + item.real_name | translate }}
            </ng-template>
          </ng-select>

          <div
            class="error-text"
            *ngIf="
              form.get('vehicleTypeName')?.touched &&
              form.get('vehicleTypeName')?.invalid
            "
          >
            <span
              *ngIf="form.get('vehicleTypeName')?.hasError('required')"
              class="text-danger"
            >
              {{ "modals.add_service.field_required" | translate }}
            </span>
          </div>
        </div>

        <div>
          <label class="label_form">
            {{ "modals.add_service.brand_input" | translate }}
          </label>

          <tui-input
            formControlName="vehicleBrand"
            [tuiTextfieldLabelOutside]="true"
            class="input_form"
          >
            {{ "modals.add_service.brand_input_inside" | translate }}
          </tui-input>
          <div
            class="error-text"
            *ngIf="
              form.get('vehicleBrand')?.touched &&
              form.get('vehicleBrand')?.invalid
            "
          >
            <span
              *ngIf="form.get('vehicleBrand')?.hasError('required')"
              class="text-danger"
            >
              {{ "modals.add_service.field_required" | translate }}
            </span>
            <span
              *ngIf="form.get('vehicleBrand')?.hasError('minlength')"
              class="text-danger"
            >
              {{
                "modals.add_service.brand_minlength" | translate : { min: 2 }
              }}
            </span>
            <span
              *ngIf="form.get('vehicleBrand')?.hasError('maxlength')"
              class="text-danger"
            >
              {{
                "modals.add_service.brand_maxlength" | translate : { max: 30 }
              }}
            </span>
          </div>
        </div>

        <div>
          <label class="label_form">
            {{ "modals.add_service.model_input" | translate }}
          </label>

          <tui-input
            formControlName="vehicleModel"
            [tuiTextfieldLabelOutside]="true"
            class="input_form"
          >
            {{ "modals.add_service.model_input_inside" | translate }}
          </tui-input>
          <div
            class="error-text"
            *ngIf="
              form.get('vehicleModel')?.touched &&
              form.get('vehicleModel')?.invalid
            "
          >
            <span
              *ngIf="form.get('vehicleModel')?.hasError('required')"
              class="text-danger"
            >
              {{ "modals.add_service.field_required" | translate }}
            </span>

            <span
              *ngIf="form.get('vehicleModel')?.hasError('minlength')"
              class="text-danger"
            >
              {{
                "modals.add_service.model_minlength" | translate : { min: 1 }
              }}
            </span>
            <span
              *ngIf="form.get('vehicleModel')?.hasError('maxlength')"
              class="text-danger"
            >
              {{
                "modals.add_service.model_maxlength" | translate : { max: 30 }
              }}
            </span>
          </div>
        </div>

        <div>
          <label class="label_form">
            {{ "modals.add_service.plate_input" | translate }}
          </label>

          <tui-input
            formControlName="licensePlate"
            [tuiTextfieldLabelOutside]="true"
            class="input_form"
          >
            {{ "modals.add_service.plate_input_inside" | translate }}
          </tui-input>
          <div
            class="error-text"
            *ngIf="
              form.get('licensePlate')?.touched &&
              form.get('licensePlate')?.invalid
            "
          >
            <span
              *ngIf="form.get('licensePlate')?.hasError('required')"
              class="text-danger"
              >{{ "modals.add_service.field_required" | translate }}</span
            >
            <span
              *ngIf="form.get('licensePlate')?.hasError('minlength')"
              class="text-danger"
              >{{
                "modals.add_service.plate_minlength" | translate : { min: 2 }
              }}</span
            >
            <span
              *ngIf="form.get('licensePlate')?.hasError('maxlength')"
              class="text-danger"
              >{{
                "modals.add_service.plate_maxlength" | translate : { max: 30 }
              }}</span
            >
            <span
              *ngIf="form.get('licensePlate')?.hasError('pattern')"
              class="text-danger"
              >{{ "modals.add_service.plate_pattern" | translate }}</span
            >
          </div>
        </div>

        <div>
          <label class="label_form">
            {{ "modals.add_service.fuel_input" | translate }}*
          </label>

          <ng-select
            formControlName="vehicleFuelName"
            [items]="VehicleFuelType"
            bindValue="value"
            [searchable]="false"
            class="custom_select custom_select_single w-100"
            [placeholder]="'modals.add_service.select_fuel_type' | translate"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ "enums.fuels." + item.real_name | translate }}
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
              {{ "enums.fuels." + item.real_name | translate }}
            </ng-template>
          </ng-select>

          <div
            class="error-text"
            *ngIf="
              form.get('vehicleFuelName')?.touched &&
              form.get('vehicleFuelName')?.invalid
            "
          >
            <span
              *ngIf="form.get('vehicleFuelName')?.hasError('required')"
              class="text-danger"
            >
              {{ "modals.add_service.field_required" | translate }}
            </span>
          </div>
        </div>
      </fieldset>

      <!-- -------- Direcciones -------------------------------------- -->
      <fieldset tuiFieldset class="fieldset-container">
        <span class="text-field-set-title">
          {{ "modals.add_service.directions_section" | translate }}
        </span>

        <!-- origen -->
        <div class="address-container">
          <div class="destination-container">
            <label class="label_form">
              {{ "modals.add_service.pickup_address_input" | translate }}*
            </label>

            <input
              #originAddress
              formControlName="originAddress"
              class="input-standar"
              (input)="clearPlaceId('origin')"
              placeholder="{{
                'modals.add_service.pickup_address_input_inside' | translate
              }}"
            />
            <div
              class="error-text"
              *ngIf="
                form.get('originAddress')?.touched &&
                form.get('originAddress')?.invalid
              "
            >
              <span
                *ngIf="form.get('originAddress')?.hasError('required')"
                class="text-danger"
              >
                {{ "modals.add_service.field_required" | translate }}
              </span>
            </div>

            <div
              class="text-danger mt-1"
              *ngIf="
                form.get('originAddress')!.touched &&
                form.get('originAddressPlaceId')!.hasError('required')
              "
            >
              {{ "modals.add_service.address_must_be_selected" | translate }}
            </div>
          </div>

          <div>
            <label class="label_form">
              {{ "modals.add_service.pickup_address_info_input" | translate }}
            </label>
            <tui-input
              formControlName="originAddressDetails"
              [tuiTextfieldLabelOutside]="true"
              class="input_form"
            >
              {{
                "modals.add_service.pickup_address_info_input_inside"
                  | translate
              }}
            </tui-input>
            <div
              class="error-text"
              *ngIf="
                form.get('originAddressDetails')?.touched &&
                form.get('originAddressDetails')?.invalid
              "
            >
              <span
                *ngIf="form.get('originAddressDetails')?.hasError('maxlength')"
                class="text-danger"
              >
                {{ "modals.add_service.max_100_characters" | translate }}
              </span>
            </div>
          </div>

          <div class="checkbox-container mt-2">
            <tui-checkbox formControlName="sameOriginAddress" size="m">
            </tui-checkbox>
            <span>
              {{ "modals.add_service.same_address_input" | translate }}
            </span>
          </div>
        </div>

        <!-- destino -->

        <div class="address-container">
          <div class="destination-container">
            <label class="label_form">
              {{ "modals.add_service.delivery_address_input" | translate }}*
            </label>

            <input
              #destinationAddress
              formControlName="destinationAddress"
              (input)="clearPlaceId('destination')"
              class="input-standar"
              placeholder="{{
                'modals.add_service.delivery_address_input_inside' | translate
              }}"
            />
            <div
              class="error-text"
              *ngIf="
                form.get('destinationAddress')?.touched &&
                form.get('destinationAddress')?.invalid
              "
            >
              <span
                *ngIf="form.get('destinationAddress')?.hasError('required')"
                class="text-danger"
              >
                {{ "modals.add_service.field_required" | translate }}
              </span>
            </div>

            <div
              class="text-danger mt-1"
              *ngIf="
                form.get('destinationAddress')!.touched &&
                form.get('destinationAddressPlaceId')!.hasError('required')
              "
            >
              {{ "modals.add_service.address_must_be_selected" | translate }}
            </div>
          </div>

          <div>
            <label class="label_form">
              {{ "modals.add_service.delivery_address_info_input" | translate }}
            </label>

            <tui-input
              formControlName="destinationAddressDetails"
              [tuiTextfieldLabelOutside]="true"
              class="input_form"
            >
              {{
                "modals.add_service.delivery_address_info_input_inside"
                  | translate
              }}
            </tui-input>
            <div
              class="error-text"
              *ngIf="
                form.get('destinationAddressDetails')?.touched &&
                form.get('destinationAddressDetails')?.invalid
              "
            >
              <span
                *ngIf="
                  form.get('destinationAddressDetails')?.hasError('maxlength')
                "
                class="text-danger"
              >
                {{ "modals.add_service.max_100_characters" | translate }}
              </span>
            </div>
          </div>
        </div>
      </fieldset>

      <!-- -------- Servicio ----------------------------------------- -->
      <fieldset tuiFieldset legend="Servicio" class="fieldset-container">
        <span class="text-field-set-title">{{
          "modals.add_service.service_section" | translate
        }}</span>

        <span
          *ngIf="
            type_info !== modalMode.Edit &&
            (form.get('zone')!.value == null ||
              form.get('clientName')!.value == null ||
              form.get('vehicleTypeName')!.value == null ||
              form.get('vehicleFuelName')!.value == null)
          "
        >
          {{ "modals.add_service.required_selects" | translate }}
        </span>

        <div>
          <label class="label_form">
            {{ "modals.add_service.vertical_input" | translate }}*
          </label>

          <ng-select
            formControlName="vertical"
            [items]="verticals"
            [searchable]="false"
            class="custom_select custom_select_single w-100"
            [placeholder]="'modals.add_service.select_vertical' | translate"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ "enums.verticals." + item | translate }}
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
              {{ "enums.verticals." + item | translate }}
            </ng-template>
          </ng-select>

          <div
            class="error-text"
            *ngIf="
              form.get('vertical')?.touched && form.get('vertical')?.invalid
            "
          >
            <span
              *ngIf="form.get('vertical')?.hasError('required')"
              class="text-danger"
            >
              {{ "modals.add_service.field_required" | translate }}
            </span>
          </div>
        </div>

        <!-- producto -->
        <div>
          <label class="label_form">
            {{ "modals.add_service.product_input" | translate }}*
          </label>

          <ng-select
            formControlName="product"
            [items]="productsName"
            [loading]="loadingProducts"
            class="custom_select custom_select_single w-100"
            [placeholder]="'modals.add_service.select_product' | translate"
          ></ng-select>
          <div
            class="error-text"
            *ngIf="form.get('product')?.touched && form.get('product')?.invalid"
          >
            <span
              *ngIf="form.get('product')?.hasError('required')"
              class="text-danger"
            >
              {{ "modals.add_service.field_required" | translate }}
            </span>
          </div>
        </div>

        <!-- proveedor (si aplica) -->
        <div *ngIf="showProvider">
          <label class="label_form">
            {{ "modals.add_service.provider_input" | translate }}
          </label>

          <ng-select
            formControlName="provider"
            class="custom_select custom_select_single w-100"
            [items]="providersName"
            [loading]="providersLoading"
            [placeholder]="providerPlaceholder | translate"
            [searchable]="false"
          >
          </ng-select>

          <!-- error de validación -->
          <div
            class="error-text"
            *ngIf="
              form.get('provider')?.touched && form.get('provider')?.invalid
            "
          >
            <span
              *ngIf="form.get('provider')?.hasError('required')"
              class="text-danger"
            >
              {{ "modals.add_service.field_required" | translate }}
            </span>
          </div>

          <!-- aviso cuando no hay proveedores -->
          <div
            *ngIf="!providersLoading && providersName.length === 0"
            class="mt-no-providers"
          >
            <span>
              {{ "modals.add_service.no_providers_available_zone" | translate }}
            </span>
          </div>
        </div>

        <!-- dirección taller 360-ITV [ER] - MANTENGO EL CODIGO PERO EL BACKEND NO LLEGO A GUARDAR ESTA INFO -->
        <!-- <div *ngIf="showGarageAddr">
          <label for="" class="label_form">
            {{ "modals.add_service.garage_addr" | translate }}</label
          >
          <tui-input
            #providerAddress
            formControlName="providerAddress"
            [tuiTextfieldLabelOutside]="true"
            class="input_form"
          >
            {{ "modals.add_service.garage_addr" | translate }}
          </tui-input>
          <div
            class="error-text"
            *ngIf="
              form.get('providerAddress')?.touched &&
              form.get('providerAddress')?.invalid
            "
          >
            <span
              *ngIf="form.get('providerAddress')?.hasError('required')"
              class="text-danger"
            >
              {{ "modals.add_service.field_required" | translate }}
            </span>
          </div>
        </div> -->

        <div *ngIf="activeVerticalValue === REFUELINGVERTICAL">
          <div class="form-group">
            <label class="label_form">
              {{ "modals.add_service.amount" | translate }}*
            </label>

            <ng-select
              formControlName="monetaryAmount"
              [items]="monetarys"
              [placeholder]="'modals.add_service.select_amount' | translate"
              [searchable]="false"
              class="custom_select custom_select_single w-100"
            >
              <ng-template ng-option-tmp let-item="item">
                {{ item }}{{ currency ? " " + currency : "" }}
              </ng-template>

              <ng-template ng-label-tmp let-item="item">
                {{ item }}{{ currency ? " " + currency : "" }}
              </ng-template>
            </ng-select>

            <div
              class="error-text"
              *ngIf="
                form.get('monetaryAmount')?.touched &&
                form.get('monetaryAmount')?.invalid
              "
            >
              <span
                *ngIf="form.get('monetaryAmount')?.hasError('required')"
                class="text-danger"
              >
                {{ "modals.add_service.field_required" | translate }}
              </span>
            </div>
          </div>
        </div>

        <!-- itv -->
        <div *ngIf="activeVerticalValue === ITVVERTICAL" class="itv-container">
          <div>
            <label for="" class="label_form">{{
              "modals.add_service.appointment_code" | translate
            }}</label>

            <tui-input
              formControlName="appointmentCode"
              [tuiTextfieldLabelOutside]="true"
              class="input_form"
            >
              {{
                "modals.add_service.enter_appointment_code" | translate
              }}</tui-input
            >

            <div class="error-text">
              <span
                class="text-danger"
                *ngIf="
                  form.get('appointmentCode')!.invalid &&
                  form.get('appointmentCode')!.touched
                "
                >{{ "modals.add_service.field_required" | translate }}</span
              >
            </div>
          </div>

          <div class="checkbox-container mt-custom">
            <tui-checkbox
              formControlName="isInspectionPaid"
              size="m"
            ></tui-checkbox>

            <span>{{ "modals.add_service.itv_paid" | translate }}</span>
          </div>

          <!-- ER [23/07/2025] - No existen estos campos en nuestro proto y jamas se almacenan -->
          <!-- <div class="row gx-2">
            <div class="col">
              <label for="" class="label_form">{{
                "modals.add_service.appointment_date" | translate
              }}</label>

              <input
                type="date"
                formControlName="appointmentDate"
                class="form-control"
              />
            </div>

            <div class="col">
              <label for="" class="label_form">
                {{ "modals.add_service.appointment_hour" | translate }}</label
              >

              <input
                type="time"
                formControlName="appointmentHour"
                class="form-control"
              />
            </div>
          </div> -->
        </div>

        <!--  
        NEUMATICOS
        -->

        <div
          *ngIf="activeVerticalValue === TYRESVERTICAL"
          class="tyres-container"
        >
          <!-- 1) Tipo de pedido -->
          <div class="tyres-section">
            <h3>
              {{ "modals.add_service.tyre_order_type_section" | translate }}*
            </h3>
            <div class="input-radio-container">
              <div class="tui-radio-item">
                <tui-radio
                  formControlName="tyreOrderType"
                  [item]="'4iguales'"
                  size="m"
                ></tui-radio>
                <span>{{
                  "modals.add_service.tyre_order_option_4equal" | translate
                }}</span>
              </div>
              <div class="tui-radio-item">
                <tui-radio
                  formControlName="tyreOrderType"
                  [item]="'2x2'"
                  size="m"
                ></tui-radio>
                <span>{{
                  "modals.add_service.tyre_order_option_2x2" | translate
                }}</span>
              </div>
              <div class="tui-radio-item">
                <tui-radio
                  formControlName="tyreOrderType"
                  [item]="'custom'"
                  size="m"
                ></tui-radio>
                <span>{{
                  "modals.add_service.tyre_order_option_custom" | translate
                }}</span>
              </div>
            </div>

            <div
              class="error-text"
              *ngIf="
                form.get('tyreOrderType')!.invalid &&
                (form.get('tyreOrderType')!.touched ||
                  form.get('tyreOrderType')!.dirty)
              "
            >
              <span class="text-danger">
                {{ "modals.add_service.tyre_order_error" | translate }}
              </span>
            </div>

            <button
              tuiButton
              appearance="outline"
              size="s"
              *ngIf="form.get('tyreOrderType')!.value === 'custom'"
              (click)="addCustomTyre()"
              class="edit-button"
            >
              {{ "modals.add_service.add_tyre" | translate }}
            </button>
          </div>

          <!-- Custom array de neumáticos -->
          <div
            *ngIf="form.get('tyreOrderType')!.value === 'custom'"
            formArrayName="extras"
            class="tyres-custom-container"
          >
            <div
              *ngFor="let tyreCtrl of tyresArray.controls; let i = index"
              [formGroupName]="i"
              class="tyres-section tyre-panel"
            >
              <div class="tyre-panel-header">
                <h3 class="tyre-section-title">
                  {{ "modals.add_service.tyre_panel_title" | translate }}
                  {{ i + 1 }}
                </h3>
                <button
                  type="button"
                  class="tyre-panel-action"
                  (click)="removeCustomTyre(i)"
                >
                  <img [src]="redTrashIcon" />
                </button>
              </div>

              <!-- Información del Neumático -->
              <div class="input-radio-container">
                <div class="tui-radio-item">
                  <tui-radio
                    formControlName="tyreSeason"
                    [item]="'verano'"
                    size="m"
                  ></tui-radio>
                  <span>{{
                    "modals.add_service.tyre_season_summer" | translate
                  }}</span>
                </div>
                <div class="tui-radio-item">
                  <tui-radio
                    formControlName="tyreSeason"
                    [item]="'invierno'"
                    size="m"
                  ></tui-radio>
                  <span>{{
                    "modals.add_service.tyre_season_winter" | translate
                  }}</span>
                </div>
                <div class="tui-radio-item">
                  <tui-radio
                    formControlName="tyreSeason"
                    [item]="'4estaciones'"
                    size="m"
                  ></tui-radio>
                  <span>{{
                    "modals.add_service.tyre_season_all" | translate
                  }}</span>
                </div>
              </div>

              <div
                *ngIf="
                  tyresArray.at(i).get('tyreSeason')!.invalid &&
                  (tyresArray.at(i).get('tyreSeason')!.touched ||
                    tyresArray.at(i).get('tyreSeason')!.dirty)
                "
              >
                <span class="error-text">{{
                  "modals.add_service.tyre_season_error" | translate
                }}</span>
              </div>

              <hr class="m-2" />

              <div class="input-checkbox-container">
                <div class="tui-checkbox-item">
                  <tui-checkbox
                    formControlName="withStuds"
                    size="m"
                  ></tui-checkbox>
                  <span>{{ "modals.add_service.with_studs" | translate }}</span>
                </div>
                <div class="tui-checkbox-item">
                  <tui-checkbox
                    formControlName="exchangeOld"
                    size="m"
                  ></tui-checkbox>
                  <span>{{
                    "modals.add_service.exchange_old" | translate
                  }}</span>
                </div>
              </div>

              <div class="tyre-dims mt-6">
                <div>
                  <label class="label_form"
                    >{{ "modals.add_service.tyre_width" | translate }}*</label
                  >
                  <tui-input
                    formControlName="tyreWidth"
                    [tuiTextfieldLabelOutside]="true"
                    class="input_form"
                    >{{
                      "modals.add_service.tyre_width_placeholder" | translate
                    }}</tui-input
                  >

                  <div
                    *ngIf="
                      tyresArray.at(i).get('tyreWidth')!.invalid &&
                      tyresArray.at(i).get('tyreWidth')!.touched
                    "
                  >
                    <span
                      *ngIf="
                        tyresArray.at(i).get('tyreWidth')?.hasError('required')
                      "
                      class="text-danger"
                    >
                      {{ "modals.add_service.field_required" | translate }}
                    </span>
                    <span
                      *ngIf="
                        tyresArray.at(i).get('tyreWidth')?.hasError('pattern')
                      "
                      class="text-danger"
                    >
                      {{ "modals.add_service.field_numeric" | translate }}
                    </span>
                  </div>
                </div>
                <div>
                  <label class="label_form">
                    {{ "modals.add_service.tyre_series" | translate }}*</label
                  >
                  <tui-input
                    formControlName="tyreSeries"
                    [tuiTextfieldLabelOutside]="true"
                    class="input_form"
                    >{{
                      "modals.add_service.tyre_series_placeholder" | translate
                    }}</tui-input
                  >

                  <div
                    *ngIf="
                      tyresArray.at(i).get('tyreSeries')!.invalid &&
                      tyresArray.at(i).get('tyreSeries')!.touched
                    "
                  >
                    <span
                      *ngIf="
                        tyresArray.at(i).get('tyreSeries')?.hasError('required')
                      "
                      class="text-danger"
                    >
                      {{ "modals.add_service.field_required" | translate }}
                    </span>
                    <span
                      *ngIf="
                        tyresArray.at(i).get('tyreSeries')?.hasError('pattern')
                      "
                      class="text-danger"
                    >
                      {{ "modals.add_service.field_numeric" | translate }}
                    </span>
                  </div>
                </div>
                <div>
                  <label class="label_form">
                    {{
                      "modals.add_service.tyre_diameter_radio" | translate
                    }}*</label
                  >
                  <tui-input
                    formControlName="tyreDiameter"
                    [tuiTextfieldLabelOutside]="true"
                    class="input_form"
                    >{{
                      "modals.add_service.tyre_diameter_radio_placeholder"
                        | translate
                    }}</tui-input
                  >

                  <div
                    *ngIf="
                      tyresArray.at(i).get('tyreDiameter')!.invalid &&
                      tyresArray.at(i).get('tyreDiameter')!.touched
                    "
                  >
                    <span
                      *ngIf="
                        tyresArray
                          .at(i)
                          .get('tyreDiameter')
                          ?.hasError('required')
                      "
                      class="text-danger"
                    >
                      {{ "modals.add_service.field_required" | translate }}
                    </span>
                    <span
                      *ngIf="
                        tyresArray
                          .at(i)
                          .get('tyreDiameter')
                          ?.hasError('pattern')
                      "
                      class="text-danger"
                    >
                      {{ "modals.add_service.field_numeric" | translate }}
                    </span>
                  </div>
                </div>
                <div>
                  <label class="label_form">
                    {{
                      "modals.add_service.tyre_load_index" | translate
                    }}*</label
                  >
                  <tui-input
                    formControlName="tyreLoadIndex"
                    [tuiTextfieldLabelOutside]="true"
                    class="input_form"
                  >
                    {{
                      "modals.add_service.tyre_load_index_placeholder"
                        | translate
                    }}</tui-input
                  >
                  <div
                    *ngIf="
                      tyresArray.at(i).get('tyreLoadIndex')!.invalid &&
                      tyresArray.at(i).get('tyreLoadIndex')!.touched
                    "
                  >
                    <span
                      *ngIf="
                        tyresArray
                          .at(i)
                          .get('tyreLoadIndex')
                          ?.hasError('required')
                      "
                      class="text-danger"
                    >
                      {{ "modals.add_service.field_required" | translate }}
                    </span>
                    <span
                      *ngIf="
                        tyresArray
                          .at(i)
                          .get('tyreLoadIndex')
                          ?.hasError('pattern')
                      "
                      class="text-danger"
                    >
                      {{ "modals.add_service.field_numeric" | translate }}
                    </span>
                  </div>
                </div>
                <div>
                  <label class="label_form"
                    >{{
                      "modals.add_service.tyre_speed_index" | translate
                    }}*</label
                  >
                  <tui-input
                    formControlName="tyreSpeedIndex"
                    [tuiTextfieldLabelOutside]="true"
                    class="input_form"
                    >{{
                      "modals.add_service.tyre_speed_index_placeholder"
                        | translate
                    }}</tui-input
                  >
                  <div
                    *ngIf="
                      tyresArray.at(i).get('tyreSpeedIndex')!.invalid &&
                      tyresArray.at(i).get('tyreSpeedIndex')!.touched
                    "
                  >
                    <span
                      *ngIf="
                        tyresArray
                          .at(i)
                          .get('tyreSpeedIndex')
                          ?.hasError('required')
                      "
                      class="text-danger"
                    >
                      {{ "modals.add_service.field_required" | translate }}
                    </span>
                    <span
                      *ngIf="
                        tyresArray
                          .at(i)
                          .get('tyreSpeedIndex')
                          ?.hasError('pattern')
                      "
                      class="text-danger"
                    >
                      {{ "modals.add_service.field_letters" | translate }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- Marca y Modelo -->
              <div class="tyre-brand-model">
                <div>
                  <label class="label_form"
                    >{{ "modals.add_service.tyre_brand" | translate }}*</label
                  >
                  <tui-input
                    formControlName="tyreBrand"
                    [tuiTextfieldLabelOutside]="true"
                    class="input_form"
                    >{{
                      "modals.add_service.tyre_brand_placeholder" | translate
                    }}</tui-input
                  >
                  <div
                    *ngIf="
                      tyresArray.at(i).get('tyreBrand')!.invalid &&
                      tyresArray.at(i).get('tyreBrand')!.touched
                    "
                  >
                    <span
                      *ngIf="
                        tyresArray.at(i).get('tyreBrand')?.hasError('required')
                      "
                      class="text-danger"
                    >
                      {{ "modals.add_service.field_required" | translate }}
                    </span>
                  </div>
                </div>
                <div>
                  <label class="label_form"
                    >{{ "modals.add_service.tyre_model" | translate }}*</label
                  >
                  <tui-input
                    formControlName="tyreModel"
                    [tuiTextfieldLabelOutside]="true"
                    class="input_form"
                  >
                    {{
                      "modals.add_service.tyre_model_placeholder" | translate
                    }}</tui-input
                  >
                  <div
                    *ngIf="
                      tyresArray.at(i).get('tyreModel')!.invalid &&
                      tyresArray.at(i).get('tyreModel')!.touched
                    "
                  >
                    <span
                      *ngIf="
                        tyresArray.at(i).get('tyreModel')?.hasError('required')
                      "
                      class="text-danger"
                    >
                      {{ "modals.add_service.field_required" | translate }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- Cantidad y Coste -->
              <div class="tyre-count-cost">
                <div>
                  <label class="label_form"
                    >{{ "modals.add_service.tyre_count" | translate }}*</label
                  >
                  <tui-input
                    formControlName="tyreCount"
                    [tuiTextfieldLabelOutside]="true"
                    class="input_form"
                    type="number"
                    >{{
                      "modals.add_service.tyre_count_placeholder" | translate
                    }}</tui-input
                  >
                  <div
                    *ngIf="
                      tyresArray.at(i).get('tyreCount')!.invalid &&
                      tyresArray.at(i).get('tyreCount')!.touched
                    "
                  >
                    <span
                      *ngIf="
                        tyresArray.at(i).get('tyreCount')?.hasError('required')
                      "
                      class="text-danger"
                    >
                      {{ "modals.add_service.field_required" | translate }}
                    </span>
                    <span
                      *ngIf="
                        tyresArray.at(i).get('tyreCount')?.hasError('pattern')
                      "
                      class="text-danger"
                    >
                      {{ "modals.add_service.field_numeric" | translate }}
                    </span>
                  </div>
                </div>
                <div>
                  <label class="label_form">
                    {{
                      "modals.add_service.tyre_unit_cost"
                        | translate : { currency: currency || "€" }
                    }}*
                  </label>
                  <tui-input
                    formControlName="tyreUnitCost"
                    [tuiTextfieldLabelOutside]="true"
                    class="input_form"
                    type="number"
                    >{{
                      "modals.add_service.tyre_unit_cost_placeholder"
                        | translate
                    }}</tui-input
                  >
                  <div
                    *ngIf="
                      tyresArray.at(i).get('tyreUnitCost')!.invalid &&
                      tyresArray.at(i).get('tyreUnitCost')!.touched
                    "
                  >
                    <span
                      *ngIf="
                        tyresArray
                          .at(i)
                          .get('tyreUnitCost')
                          ?.hasError('required')
                      "
                      class="text-danger"
                    >
                      {{ "modals.add_service.field_required" | translate }}
                    </span>
                    <span
                      *ngIf="
                        tyresArray
                          .at(i)
                          .get('tyreUnitCost')
                          ?.hasError('pattern')
                      "
                      class="text-danger"
                    >
                      {{ "modals.add_service.field_numeric" | translate }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 2) Información del Neumático único -->
          <ng-container *ngIf="form.get('tyreOrderType')!.value !== 'custom'">
            <div class="tyres-section">
              <h3>
                {{ "modals.add_service.single_tyre_info_section" | translate }}
              </h3>
              <div class="input-radio-container">
                <div class="tui-radio-item">
                  <tui-radio
                    formControlName="tyreSeason"
                    [item]="'verano'"
                    size="m"
                  ></tui-radio>
                  <span>{{
                    "modals.add_service.tyre_season_summer" | translate
                  }}</span>
                </div>
                <div class="tui-radio-item">
                  <tui-radio
                    formControlName="tyreSeason"
                    [item]="'invierno'"
                    size="m"
                  ></tui-radio>
                  <span>{{
                    "modals.add_service.tyre_season_winter" | translate
                  }}</span>
                </div>
                <div class="tui-radio-item">
                  <tui-radio
                    formControlName="tyreSeason"
                    [item]="'4estaciones'"
                    size="m"
                  ></tui-radio>
                  <span>{{
                    "modals.add_service.tyre_season_all" | translate
                  }}</span>
                </div>
              </div>

              <div
                *ngIf="
                  form.get('tyreSeason')!.invalid &&
                  (form.get('tyreSeason')!.touched ||
                    form.get('tyreSeason')!.dirty)
                "
                class="error-text"
              >
                <span class="text-danger">
                  {{ "modals.add_service.tyre_season_error" | translate }}
                </span>
              </div>

              <hr class="m-2" />
              <div class="input-checkbox-container">
                <div class="tui-checkbox-item">
                  <tui-checkbox
                    formControlName="withStuds"
                    size="m"
                  ></tui-checkbox>
                  <span>{{ "modals.add_service.with_studs" | translate }}</span>
                </div>
              </div>

              <div class="tyre-dims mt-6">
                <div>
                  <label class="label_form"
                    >{{ "modals.add_service.tyre_width" | translate }}*</label
                  >
                  <tui-input
                    formControlName="tyreWidth"
                    [tuiTextfieldLabelOutside]="true"
                    class="input_form"
                  >
                    {{
                      "modals.add_service.tyre_width_placeholder" | translate
                    }}</tui-input
                  >

                  <div class="error-text">
                    <span
                      class="text-danger"
                      *ngIf="
                        form.get('tyreWidth')!.invalid &&
                        form.get('tyreWidth')!.touched &&
                      !form.get('tyreWidth')!.hasError('pattern')
                      "
                      >{{
                        "modals.add_service.field_required" | translate
                      }}</span
                    >
                    <span
                      class="text-danger"
                      *ngIf="
                        form.get('tyreWidth')!.touched &&
                        form.get('tyreWidth')!.hasError('pattern')
                      "
                      >{{ "modals.add_service.field_numeric" | translate }}</span
                    >
                  </div>
                </div>

                <div>
                  <label class="label_form">
                    {{ "modals.add_service.tyre_series" | translate }}*</label
                  >
                  <tui-input
                    formControlName="tyreSeries"
                    [tuiTextfieldLabelOutside]="true"
                    class="input_form"
                  >
                    {{
                      "modals.add_service.tyre_series_placeholder" | translate
                    }}</tui-input
                  >
                  <div class="error-text">
                    <span
                      class="text-danger"
                      *ngIf="
                        form.get('tyreSeries')!.invalid &&
                        form.get('tyreSeries')!.touched &&
                      !form.get('tyreSeries')!.hasError('pattern')
                      "
                      >{{
                        "modals.add_service.field_required" | translate
                      }}</span
                    >
                    <span
                      class="text-danger"
                      *ngIf="
                        form.get('tyreSeries')!.touched &&
                        form.get('tyreSeries')!.hasError('pattern')
                      "
                      >{{ "modals.add_service.field_numeric" | translate }}</span
                    >
                  </div>
                </div>
                <div>
                  <label class="label_form">
                    {{
                      "modals.add_service.tyre_diameter_radio" | translate
                    }}*</label
                  >
                  <tui-input
                    formControlName="tyreDiameter"
                    [tuiTextfieldLabelOutside]="true"
                    class="input_form"
                  >
                    {{
                      "modals.add_service.tyre_diameter_radio_placeholder"
                        | translate
                    }}
                  </tui-input>
                  <div class="error-text">
                    <span
                      class="text-danger"
                      *ngIf="
                        form.get('tyreDiameter')!.invalid &&
                        form.get('tyreDiameter')!.touched &&
                      !form.get('tyreDiameter')!.hasError('pattern')
                      "
                      >{{
                        "modals.add_service.field_required" | translate
                      }}</span
                    >
                    <span
                      class="text-danger"
                      *ngIf="
                        form.get('tyreDiameter')!.touched &&
                        form.get('tyreDiameter')!.hasError('pattern')
                      "
                      >{{ "modals.add_service.field_numeric" | translate }}</span
                    >
                  </div>
                </div>
                <div>
                  <label class="label_form">
                    {{
                      "modals.add_service.tyre_load_index" | translate
                    }}*</label
                  >
                  <tui-input
                    formControlName="tyreLoadIndex"
                    [tuiTextfieldLabelOutside]="true"
                    class="input_form"
                  >
                    {{
                      "modals.add_service.tyre_load_index_placeholder"
                        | translate
                    }}</tui-input>
                  <div class="error-text">
                    <span
                      class="text-danger"
                      *ngIf="
                        form.get('tyreLoadIndex')!.invalid &&
                        form.get('tyreLoadIndex')!.touched &&
                      !form.get('tyreLoadIndex')!.hasError('pattern')
                      "
                      >{{
                        "modals.add_service.field_required" | translate
                      }}</span
                    >
                    <span
                      class="text-danger"
                      *ngIf="
                        form.get('tyreLoadIndex')!.touched &&
                        form.get('tyreLoadIndex')!.hasError('pattern')
                      "
                      >{{ "modals.add_service.field_numeric" | translate }}</span
                    >
                  </div>
                </div>
                <div>
                  <label class="label_form"
                    >{{
                      "modals.add_service.tyre_speed_index" | translate
                    }}*</label
                  >
                  <tui-input
                    formControlName="tyreSpeedIndex"
                    [tuiTextfieldLabelOutside]="true"
                    class="input_form"
                  >
                    {{
                      "modals.add_service.tyre_speed_index_placeholder"
                        | translate
                    }}</tui-input>
                  <div class="error-text">
                    <span
                      class="text-danger"
                      *ngIf="
                        form.get('tyreSpeedIndex')!.invalid &&
                        form.get('tyreSpeedIndex')!.touched &&
                      !form.get('tyreSpeedIndex')!.hasError('pattern')
                      "
                      >{{
                        "modals.add_service.field_required" | translate
                      }}</span
                    >
                    <span
                      class="text-danger"
                      *ngIf="
                        form.get('tyreSpeedIndex')!.touched &&
                        form.get('tyreSpeedIndex')!.hasError('pattern')
                      "
                      >{{ "modals.add_service.field_letters" | translate }}</span
                    >
                  </div>
                </div>
              </div>

              <!-- Marca y Modelo -->
              <div class="tyre-brand-model">
                <div>
                  <label class="label_form"
                    >{{ "modals.add_service.tyre_brand" | translate }}*</label
                  >
                  <tui-input
                    formControlName="tyreBrand"
                    [tuiTextfieldLabelOutside]="true"
                    class="input_form"
                  >
                    {{
                      "modals.add_service.tyre_brand_placeholder" | translate
                    }}</tui-input>
                  <div class="error-text">
                    <span
                      class="text-danger"
                      *ngIf="
                        form.get('tyreBrand')!.invalid &&
                        form.get('tyreBrand')!.touched
                      "
                      >{{
                        "modals.add_service.field_required" | translate
                      }}</span
                    >
                  </div>
                </div>
                <div>
                  <label class="label_form"
                    >{{ "modals.add_service.tyre_model" | translate }}*</label
                  >
                  <tui-input
                    formControlName="tyreModel"
                    [tuiTextfieldLabelOutside]="true"
                    class="input_form"
                  >
                    {{
                      "modals.add_service.tyre_model_placeholder" | translate
                    }}</tui-input>
                  <div class="error-text">
                    <span
                      class="text-danger"
                      *ngIf="
                        form.get('tyreModel')!.invalid &&
                        form.get('tyreModel')!.touched
                      "
                      >{{
                        "modals.add_service.field_required" | translate
                      }}</span
                    >
                  </div>
                </div>
              </div>

              <!-- Cantidad y Coste -->
              <div class="tyre-count-cost">
                <div>
                  <label class="label_form">
                    {{ "modals.add_service.tyre_count" | translate }}*</label
                  >
                  <tui-input
                    formControlName="tyreCount"
                    [tuiTextfieldLabelOutside]="true"
                    class="input_form"
                    type="number"
                    >{{
                      "modals.add_service.tyre_count_placeholder" | translate
                    }}</tui-input
                  >
                  <div class="error-text">
                    <span
                      class="text-danger"
                      *ngIf="
                        form.get('tyreCount')!.invalid &&
                        form.get('tyreCount')!.touched &&
                      !form.get('tyreCount')!.hasError('pattern')
                      "
                      >{{
                        "modals.add_service.field_required" | translate
                      }}</span
                    >
                    <span
                      class="text-danger"
                      *ngIf="
                        form.get('tyreCount')!.touched &&
                        form.get('tyreCount')!.hasError('pattern')
                      "
                      >{{ "modals.add_service.field_numeric" | translate }}</span
                    >
                  </div>
                </div>
                <div>
                  <label class="label_form">
                    {{
                      "modals.add_service.tyre_unit_cost"
                        | translate : { currency: currency || "€" }
                    }}*
                  </label>
                  <tui-input
                    formControlName="tyreUnitCost"
                    [tuiTextfieldLabelOutside]="true"
                    class="input_form"
                    type="number"
                    >{{
                      "modals.add_service.tyre_unit_cost_placeholder"
                        | translate
                    }}</tui-input
                  >
                  <div class="error-text">
                    <span
                      class="text-danger"
                      *ngIf="
                        form.get('tyreUnitCost')!.invalid &&
                        form.get('tyreUnitCost')!.touched &&
                      !form.get('tyreUnitCost')!.hasError('pattern')
                      "
                      >{{
                        "modals.add_service.field_required" | translate
                      }}</span
                    >
                    <span
                      class="text-danger"
                      *ngIf="
                        form.get('tyreUnitCost')!.touched &&
                        form.get('tyreUnitCost')!.hasError('pattern')
                      "
                      >{{ "modals.add_service.field_numeric" | translate }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- 3) Servicio de Entrega y Montaje -->
          <div class="tyres-section">
            <h3>
              {{
                "modals.add_service.delivery_and_mounting_options" | translate
              }}*
            </h3>
            <div class="tui-radio-item" *ngIf="!isCopec">
              <tui-radio
                formControlName="serviceOption"
                [item]="'movilidad'"
                size="m"
              ></tui-radio>
              <span>{{
                "modals.add_service.option_mobility_with_mount" | translate
              }}</span>
            </div>
          <!--   <div class="tui-radio-item">
              <tui-radio
                formControlName="serviceOption"
                [item]="'sin-movilidad'"
                size="m"
              ></tui-radio>
              <span>{{
                "modals.add_service.option_no_mobility_with_mount" | translate
              }}</span>
            </div> -->
            <div class="tui-radio-item">
              <tui-radio
                formControlName="serviceOption"
                [item]="'envio'"
                size="m"
              ></tui-radio>
              <span>{{
                "modals.add_service.option_shipping" | translate
              }}</span>
            </div>
            <div class="tui-radio-item">
              <tui-radio
                formControlName="serviceOption"
                [item]="'montaje-domicilio'"
                size="m"
              ></tui-radio>
              <span>{{
                "modals.add_service.option_home_mount" | translate
              }}</span>
            </div>

            <div
              class="error-text"
              *ngIf="
                form.get('serviceOption')!.invalid &&
                (form.get('serviceOption')!.touched ||
                  form.get('serviceOption')!.dirty)
              "
            >
              <span class="text-danger">
                {{
                  "modals.add_service.error_select_service_option" | translate
                }}
              </span>
            </div>
          </div>

          <!-- 4) Información Adicional -->
          <div class="tyres-section">
            <h3>
              {{ "modals.add_service.additional_information" | translate }}
            </h3>
            <div class="checkbox-container">
              <tui-checkbox
                formControlName="needAlignment"
                size="m"
              ></tui-checkbox>
              <span>{{
                "modals.add_service.request_alignment" | translate
              }}</span>
            </div>
               <div class="tui-checkbox-item">
                  <tui-checkbox
                    formControlName="exchangeOld"
                    size="m"
                  ></tui-checkbox>
                  <span>{{
                    "modals.add_service.exchange_old" | translate
                  }}</span>
                </div>
                <span class="note">{{ "modals.add_service.additional_cost_60" | translate : { amount: additionalCostAmount } }}</span>
          </div>
        </div>
      </fieldset>

      <!-- -------- Contactos ---------------------------------------- -->
      <fieldset
        tuiFieldset
        legend="Contacto – Origen"
        class="fieldset-container"
      >
        <span class="text-field-set-title">
          {{ "modals.add_service.contact_origin_title" | translate }}</span
        >

        <div class="row gx-2">
          <div class="col checkbox-container">
            <tui-radio
              formControlName="isOriginContactExternal"
              [item]="false"
              size="m"
            ></tui-radio>
            <span>{{ "modals.add_service.internal" | translate }}</span>
          </div>
          <div class="col checkbox-container">
            <tui-radio
              formControlName="isOriginContactExternal"
              [item]="true"
              size="m"
            ></tui-radio>
            <span>{{ "modals.add_service.external" | translate }}</span>
          </div>
        </div>

        <div>
          <label for="" class="label_form"
            >{{ "modals.add_service.name_input" | translate }}*</label
          >

          <tui-input
            formControlName="originContactName"
            [tuiTextfieldLabelOutside]="true"
            class="input_form"
            >{{ "modals.add_service.name_placeholder" | translate }}</tui-input
          >
          <div
            class="error-text"
            *ngIf="
              form.get('originContactName')?.touched &&
              form.get('originContactName')?.invalid
            "
          >
            <span
              *ngIf="form.get('originContactName')?.hasError('required')"
              class="text-danger"
            >
              {{ "modals.add_service.field_required" | translate }}
            </span>
          </div>
        </div>

        <div>
          <label for="" class="label_form"
            >{{ "modals.add_service.phone_input" | translate }}*</label
          >

          <tui-input-phone-international
            [tuiTextfieldLabelOutside]="true"
            formControlName="originContactPhoneNumber"
            [countries]="(countryCodes | tuiSortCountries | async) || []"
            [countryIsoCode]="
              form.get('originalContactPhoneNumberPhoneIso')?.value
            "
            (countryIsoCodeChange)="
              form.get('originalContactPhoneNumberPhoneIso')?.setValue($event)
            "
            (click)="openPhoneContainer($event)"
            class="input_form"
          >
            {{ "modals.add_service.phone_placeholder" | translate }}
          </tui-input-phone-international>

          <div
            class="error-text"
            *ngIf="
              form.get('originContactPhoneNumber')?.touched &&
              form.get('originContactPhoneNumber')?.invalid
            "
          >
            <span
              *ngIf="form.get('originContactPhoneNumber')?.hasError('required')"
              class="text-danger"
            >
              {{ "modals.add_service.field_required" | translate }}
            </span>
            <span
              *ngIf="form.get('originContactPhoneNumber')?.hasError('pattern')"
              class="text-danger"
            >
              {{ "modals.add_service.invalid_phone_format" | translate }}
            </span>
          </div>
        </div>

        <div>
          <label for="" class="label_form"
            >{{ "modals.add_service.email_input" | translate }}</label
          >

          <tui-input
            class="input_form"
            formControlName="originContactEmailAddress"
            [tuiTextfieldLabelOutside]="true"
            >{{ "modals.add_service.email_placeholder" | translate }}
          </tui-input>
          <div
            class="error-text"
            *ngIf="
              form.get('originContactEmailAddress')?.touched &&
              form.get('originContactEmailAddress')?.invalid
            "
          >
            <span
              *ngIf="
                form.get('originContactEmailAddress')?.hasError('required')
              "
              class="text-danger"
            >
              {{ "modals.add_service.field_required" | translate }}
            </span>
            <span
              *ngIf="
                form
                  .get('originContactEmailAddress')
                  ?.hasError('invalidEmail') ||
                form.get('originContactEmailAddress')?.hasError('email')
              "
              class="text-danger"
            >
              {{ "modals.add_service.invalid_email" | translate }}
            </span>
          </div>
        </div>

        <app-document-type-input
          [formGroup]="form"
          typeControlName="originContactDocumentType"
          numberControlName="originContactDocumentNumber"
          labelPrefix="modals.add_personal"
        ></app-document-type-input>

        <div class="checkbox-container mt-2">
          <tui-checkbox
            formControlName="sameContactOriginDestiny"
            size="m"
          ></tui-checkbox>
          <span>
            {{
              "modals.add_service.same_origin_and_destiny_contact" | translate
            }}
          </span>
        </div>
      </fieldset>

      <!-- Contacto destino -->
      <fieldset
        tuiFieldset
        legend="Contacto – Destino"
        class="fieldset-container"
      >
        <span class="text-field-set-title">{{
          "modals.add_service.contact_destiny_title" | translate
        }}</span>

        <div class="row gx-2">
          <div class="col checkbox-container">
            <tui-radio
              formControlName="isDestinationContactExternal"
              [item]="false"
              size="m"
            ></tui-radio>
            <span>{{ "modals.add_service.internal" | translate }}</span>
          </div>
          <div class="col checkbox-container">
            <tui-radio
              formControlName="isDestinationContactExternal"
              [item]="true"
              size="m"
            ></tui-radio>
            <span>{{ "modals.add_service.external" | translate }}</span>
          </div>
        </div>

        <div>
          <label for="" class="label_form"
            >{{ "modals.add_service.name_input" | translate }}*</label
          >

          <tui-input
            formControlName="destinationContactName"
            [tuiTextfieldLabelOutside]="true"
            class="input_form"
          >
            {{ "modals.add_service.name_placeholder" | translate }}
          </tui-input>
          <div
            class="error-text"
            *ngIf="
              form.get('destinationContactName')?.touched &&
              form.get('destinationContactName')?.invalid
            "
          >
            <span
              *ngIf="form.get('destinationContactName')?.hasError('required')"
              class="text-danger"
            >
              {{ "modals.add_service.field_required" | translate }}
            </span>
          </div>
        </div>

        <div>
          <label for="" class="label_form"
            >{{ "modals.add_service.phone_input" | translate }}*</label
          >

          <!-- nuevo -->
          <tui-input-phone-international
            [tuiTextfieldLabelOutside]="true"
            formControlName="destinationContactPhoneNumber"
            [countries]="(countryCodes | tuiSortCountries | async) || []"
            [countryIsoCode]="form.get('destinationContactPhoneIso')?.value"
            (countryIsoCodeChange)="
              form.get('destinationContactPhoneIso')?.setValue($event)
            "
            (click)="openPhoneContainer($event)"
            class="input_form"
          >
            {{ "modals.add_service.phone_placeholder" | translate }}
          </tui-input-phone-international>

          <div
            class="error-text"
            *ngIf="
              form.get('destinationContactPhoneNumber')?.touched &&
              form.get('destinationContactPhoneNumber')?.invalid
            "
          >
            <span
              *ngIf="
                form.get('destinationContactPhoneNumber')?.hasError('required')
              "
              class="text-danger"
            >
              {{ "modals.add_service.field_required" | translate }}
            </span>
            <span
              *ngIf="
                form.get('destinationContactPhoneNumber')?.hasError('pattern')
              "
              class="text-danger"
            >
              {{ "modals.add_service.invalid_phone_format" | translate }}
            </span>
          </div>
        </div>

        <div>
          <label for="" class="label_form"
            >{{ "modals.add_service.email_input" | translate }}</label
          >

          <tui-input
            formControlName="destinationContactEmailAddress"
            [tuiTextfieldLabelOutside]="true"
            class="input_form"
            >{{ "modals.add_service.email_placeholder" | translate }}</tui-input
          >

          <div
            class="error-text"
            *ngIf="
              form.get('destinationContactEmailAddress')?.touched &&
              form.get('destinationContactEmailAddress')?.invalid
            "
          >
            <span
              *ngIf="
                form.get('destinationContactEmailAddress')?.hasError('required')
              "
              class="text-danger"
            >
              {{ "modals.add_service.field_required" | translate }}
            </span>

            <span
              *ngIf="
                form
                  .get('destinationContactEmailAddress')
                  ?.hasError('invalidEmail') ||
                form.get('destinationContactEmailAddress')?.hasError('email')
              "
              class="text-danger"
            >
              {{ "modals.add_service.invalid_email" | translate }}
            </span>
          </div>
        </div>

        <app-document-type-input
          [formGroup]="form"
          typeControlName="destinationContactDocumentType"
          numberControlName="destinationContactDocumentNumber"
          labelPrefix="modals.add_personal"
        ></app-document-type-input>
      </fieldset>

      <ng-container *ngIf="!isCopec && !isOkMobilityTenant">
      <fieldset tuiFieldset class="fieldset-container">
        <span class="text-field-set-title">
          {{ "modals.add_service.prices_section_title" | translate }}
        </span>

        <strong class="prices-subsection-title">
          {{ "modals.add_service.prices_products_subtitle" | translate }}
        </strong>

        <div>
          <label class="label_form">{{ form.get('product')?.value || ('modals.add_service.product_input' | translate) }}</label>
          <tui-input
            formControlName="customProductPrice"
            [tuiTextfieldLabelOutside]="true"
            class="input_form"
            type="number"
          >
            {{ currency || '€' }}
          </tui-input>
        </div>

        <div class="notification-container mt-2">
          <tui-icon class="mr-2" icon="tuiIconInfoLarge"></tui-icon>
          <span>{{ "modals.add_service.prices_auto_calc_info" | translate }}</span>
        </div>

        <!-- Costes adicionales -->
        <strong class="prices-subsection-title">
          {{ "modals.add_service.prices_additional_costs_subtitle" | translate }}
        </strong>

        <!-- Tasa de Cafler -->
        <div>
          <label class="label_form  mb-2">{{ "modals.add_service.cafler_fee_label" | translate }}</label>
          <tui-input
            formControlName="customCaflerFee"
            [tuiTextfieldLabelOutside]="true"
            class="input_form"
            type="number"
          >
            {{ currency || '€' }}
          </tui-input>
          <p class="prices-fee-description fee_label_color mt-2">{{ "modals.add_service.cafler_fee_description" | translate }}</p>
        </div>

        <div>
          <label class="label_form">{{ "modals.add_service.fixed_fee_label" | translate }}</label>
          <p class="prices-fee-question fee_label_color mt-3">{{ "modals.add_service.fixed_fee_question" | translate }}</p>
          <div class="checkbox-container mt-3">
            <tui-checkbox formControlName="addFixedFee" size="m"></tui-checkbox>
            <span>{{ "modals.add_service.yes_add_fee" | translate }}</span>
          </div>
        </div>

        <div>
          <label class="label_form mt-2">{{ "modals.add_service.urgency_fee_label" | translate }}</label>
          <div class="notification-container mt-2">
            <tui-icon class="mr-2" icon="tuiIconInfoLarge"></tui-icon>
            <span>{{ "modals.add_service.urgency_fee_info" | translate }}</span>
          </div>
          <p class="prices-fee-question fee_label_color mt-2">{{ "modals.add_service.urgency_fee_question" | translate }}</p>
          <div class="checkbox-container mt-3">
            <tui-checkbox formControlName="addUrgencyFee" size="m"></tui-checkbox>
            <span>{{ "modals.add_service.yes_add_fee" | translate }}</span>
          </div>
        </div>
      </fieldset>
      </ng-container>

      <ng-container *ngIf="!isCopec && !isOkMobilityTenant">
      <fieldset tuiFieldset class="fieldset-container">
        <span class="text-field-set-title">
          {{ "modals.add_service.pool_section_title" | translate }}
        </span>

        <p class="prices-fee-question fee_label_color">
          {{ "modals.add_service.pool_section_question" | translate }}
        </p>

        <div class="checkbox-container">
          <tui-checkbox formControlName="isPoolService" size="m"></tui-checkbox>
          <span>{{ "modals.add_service.yes_enable_option" | translate }}</span>
        </div>

        <ng-container *ngIf="form.get('isPoolService')?.value">
          <div style="margin-top: 16px;">
            <label class="label_form">{{ "modals.add_service.pool_price_label" | translate }} ({{ currency || '€' }})</label>
            <tui-input
              formControlName="customPoolPrice"
              [tuiTextfieldLabelOutside]="true"
              class="input_form"
              type="number"
            >
              {{ currency || '€' }}
            </tui-input>
          </div>

          <div class="pool-margin-container" style="margin-top: 12px;">
            <span>{{ "modals.add_service.pool_margin_info" | translate }}</span>
            <div class="pool-margin-display">
              <span>
                <strong>{{ "modals.add_service.pool_margin_amount_label" | translate }} ({{ currency || '€' }}):</strong>
                {{ marginAmount | number:'1.2-2' }}{{ currency || '€' }}
              </span>
              <span>
                <strong>{{ "modals.add_service.pool_margin_pct_label" | translate }}:</strong>
                {{ marginPercentage | number:'1.0-2' }}%
              </span>
            </div>
          </div>
        </ng-container>
      </fieldset>
      </ng-container>

      <fieldset
        tuiFieldset
        legend="Contacto – Destino"
        class="fieldset-container"
      >
        <span class="text-field-set-title">
          {{ "modals.add_service.comments_section_title" | translate }}</span
        >

        <div class="additional-info-section" *ngIf="type_info !== modalMode.Edit">
          <div *ngIf="!deliveryNoteId">
            <app-delivery-note-upload-button
              (upload)="openDeliveryNoteUploadModal()"
              [isLoading]="isSaving"
            ></app-delivery-note-upload-button>
          </div>

          <div *ngIf="deliveryNoteId">
            <span class="delivery-note-label">{{ 'delivery-note.delivery-note_section_title' | translate }}</span>
            <div class="attached-file-container">
              <tui-icon icon="tuiIconFile" class="file-icon"></tui-icon>
              <div class="file-info-content">
                <p class="file-name">{{ deliveryNoteName }}</p>
                <div class="file-meta">
                  <span class="file-date" *ngIf="deliveryNoteDate">{{ 'delivery-note.uploaded_on' | translate }}: {{ deliveryNoteDate }}</span>
                  <span class="file-size" *ngIf="deliveryNoteSize">{{ deliveryNoteSize }}</span>
                </div>
              </div>
              <button
                type="button"
                tuiIconButton
                appearance="link"
                icon="tuiIconTrash"
                size="s"
                (click)="removeDeliveryNote()"
                [disabled]="isSaving"
                tuiHint="{{ 'delivery-note.delete_document' | translate }}"
              ></button>
            </div>
          </div>
        </div>

        <div>
          <label for="" class="label_form">
            {{ "modals.add_service.comments_section_label" | translate }}</label
          >

          <tui-text-area
            formControlName="comments"
            [tuiTextfieldLabelOutside]="true"
            class="text-area-element"
            [rows]="3"
          >
            {{ "modals.add_service.comments_input" | translate }}
          </tui-text-area>
          <div
            class="error-text"
            *ngIf="
              form.get('comments')?.touched && form.get('comments')?.invalid
            "
          >
            <span
              *ngIf="form.get('comments')?.hasError('maxlength')"
              class="text-danger"
            >
              {{ "modals.add_service.comments_error_maxlength" | translate }}
            </span>
          </div>
        </div>
      </fieldset>
    </form>
  </div>

  <!-- ----------------------------- footer --------------------------- -->
  <div class="modal-footer">
    <button class="cancel-button" [disabled]="isSaving" (click)="closeCanvas()">
      {{ "modals.add_service.close_modal_text" | translate }}
    </button>

    <button class="confirm-button" [disabled]="isSaving" (click)="save()">
      <ng-container *ngIf="!isSaving; else loading">
        <ng-container [ngSwitch]="type_info">
          <span *ngSwitchCase="'du'">
            {{ "modals.add_service.duplicate_button_text" | translate }}
          </span>
          <span *ngSwitchCase="'ed'">
            {{ "modals.add_service.edit_button_text" | translate }}
          </span>
          <span *ngSwitchDefault>
            {{ "modals.add_service.add_button_text" | translate }}
          </span>
        </ng-container>
      </ng-container>
      <ng-template #loading>
        <tui-loader size="s"></tui-loader>
      </ng-template>
    </button>
  </div>
</div>